import { useRef, useCallback, useEffect, useMemo } from 'react'

export const useIsMounted = () => {
  const isMountedRef = useRef(true)

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const onStillMounted = useCallback((executeIfMounted: () => void) => {
    if (isMountedRef.current) {
      executeIfMounted()
    }
  }, [])

  const return_ = useMemo(() => ({ isMounted: isMountedRef, onStillMounted }), [])

  return return_
}
